import { render, staticRenderFns } from "./SiteAlert.vue?vue&type=template&id=62fb29c4&scoped=true&lang=pug"
import script from "./SiteAlert.vue?vue&type=script&lang=js"
export * from "./SiteAlert.vue?vue&type=script&lang=js"
import style0 from "./SiteAlert.vue?vue&type=style&index=0&id=62fb29c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fb29c4",
  null
  
)

export default component.exports